import { Drawer, Theme } from "@material-ui/core";
import { useEffect, useMemo } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  Radio,
  RadioGroup,
  Switch,
  TableContainer,
  Typography,
} from "@material-ui/core";
import { useState } from "react";
import { TableGroupedDeliveries } from "../components/TableGroupedDeliveries";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PersonIcon from "@material-ui/icons/Person";
import ListAltIcon from "@material-ui/icons/ListAlt";
import { Form } from "react-final-form";
import { EtaParams, useStore } from "../store";
import { EtaCalculationDialog } from "./EtaCalculationDialog";

import { ReferenceInputSubject } from "../../components/reference-inputs/ReferenceInputSubject";
import "leaflet-area-select";
import {
    RecordMap,
    Record,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    DateField,
    DateTimeInput,
    Labeled,
} from "react-admin";
import TextField from '@material-ui/core/TextField';
import { Route } from "../types";
import { useSize } from "../../shared/hooks/useSize";
import { Subject } from "../../shared/types";
import { ca } from "date-fns/locale";
import { set } from "lodash";
import {FaPeopleCarryBox} from "react-icons/fa6";
import {getUser} from "../../authProvider";

const useStylesSidebar = makeStyles<Theme, any>((theme) => ({
  paper: {
    top: "auto",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.only("sm")]: {
      height: (props) => props.height,
    },
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      maxWidth: "700px",
      height: (props) => props.height,
    },
    [theme.breakpoints.up("md")]: {
      width: "700px",
    },
  },
}));
interface SidebarProps {
  startPointSubject?: Record;
  finalPointSubject?: Record;
  simulateRouteAssignment: () => void;
  saveRoute: () => void;
  autoOrder: () => void;
  invertRouteOrder: () => void;
  routesData: RecordMap<Record>;
  setOpenDriverDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenCarrierDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenVehicleDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenRoutesDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenSplitSegmentsDialog: React.Dispatch<React.SetStateAction<boolean>>;
  handlerCarrier: boolean;
  onHandlerChange: (hC: boolean) => void;
  updateFilterOnRoutesSelection: (routes: Route[]) => void;
  pointsDurationMapping: [];
  endDate?: string;
  endDateValue: Date;
  duration: string;
  totalDistance: number;
  totalRoutingDuration: number;
  totalEtaDuration: number;
  etaParams: EtaParams;
  etaParamsLoaded: boolean;
  etaAuditEnabled: boolean;
  onCaptureEtaAudit: () => void;
  routingReady: boolean;
  setShowAllRoute: (showAllRoute: boolean) => void;
  showAllRoute: boolean;
}
export const Sidebar = (props: SidebarProps) => {
  const {
    startPointSubject,
    finalPointSubject,
    simulateRouteAssignment,
    saveRoute,
    autoOrder,
    invertRouteOrder,
    routesData,
    setOpenDriverDialog,
    setOpenCarrierDialog,
    setOpenVehicleDialog,
    setOpenRoutesDialog,
    setOpenSplitSegmentsDialog,
    handlerCarrier,
    onHandlerChange,
    updateFilterOnRoutesSelection,
    pointsDurationMapping,
    setShowAllRoute,
    showAllRoute
  } = props;


  const [open, setOpen] = useState<boolean>(true);
  const [etaDetailsOpen, setEtaDetailsOpen] = useState(false);
  const [canSaveForEta, setCanSaveForEta] = useState<string>("");
  const [canSaveForEtaTemp, setCanSaveForEtaTemp] = useState<number>(0);
  const user = getUser();

  function ignoreEtaWarning() {
    setCanSaveForEtaTemp(4);

    setTimeout(() => {
      setCanSaveForEtaTemp(3);
    }, 1000);
    setTimeout(() => {
      setCanSaveForEtaTemp(2);
    }
      , 2000);
    setTimeout(() => {
      setCanSaveForEtaTemp(1);
    }
      , 3000);
    setTimeout(() => {
      setCanSaveForEtaTemp(0);
    }
      , 4000);
  }

  const {
    editMode,
    addedSegments,
    carrier,
    driver,
    vehicle,
    groupedDeliveries,
    routes,
    selectedRoute,
    tags,
    finalPointId,
    startPointId,
    startDate,
    warehouseAlert,
    updateTags,
    updateStartPointId,
    updateFinalPointId,
    updateStartDate,
    toggleEditMode,
    deleteDeliveries,
    reorderGroupedDeliveries,
    updateSelectedRoute,
      setCreateBorderaux,
      createBorderaux
  } = useStore();
  const saveButtonDisabled = useMemo(
    () =>
      (!(vehicle && driver) && !carrier) ||
      groupedDeliveries.length <= 0 ||
      !finalPointSubject ||
      !startPointSubject ||
      (tags === undefined || tags.length <= 0) ||
      !startDate ||
      warehouseAlert ||
      !props.routingReady ||
      (canSaveForEta !== "" && canSaveForEtaTemp === 0),
    [
      driver,
      carrier,
      finalPointSubject,
      groupedDeliveries.length,
      startPointSubject,
      vehicle,
      tags,
      startDate,
      warehouseAlert,
      props.routingReady,
      canSaveForEta,
      canSaveForEtaTemp,
    ]
  );
  const simulateButtonDisabled = useMemo(
    () =>
      (!carrier) ||
      groupedDeliveries.length <= 0 ||
      !finalPointSubject ||
      !startPointSubject,
    [
      carrier,
      finalPointSubject,
      groupedDeliveries.length,
      startPointSubject,
    ]
  );
  const size = useSize(document.getElementById("layout-main-content"));

  const classes = useStylesSidebar({ height: size?.height });

  const toggleSidebar = () => setOpen((value) => !value);


  return (
    <Drawer
      variant="permanent"
      open={open}
      onClose={toggleSidebar}
      classes={classes}
      anchor="right"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center">
        <Grid container >
          <Grid xs={6} item container>
            <Grid item xs={2}>
              <Switch
                disabled={!editMode}
                checked={editMode ? showAllRoute : false}
                onChange={() =>
                  setShowAllRoute(!showAllRoute)
                }
                name="mode"
              />
            </Grid>
            <Grid item xs={10}>
              <Typography>Mostra TUTTI i percorsi su mappa</Typography>
            </Grid>
          </Grid>
          <Grid xs={6} item container>
            <Grid item xs={10} spacing-xs-1>
              <Typography align="right" >Modalità di modifica</Typography>
            </Grid>
            <Grid item xs={2}>
              <Switch
                checked={editMode}
                onChange={() =>
                  toggleEditMode(() => updateFilterOnRoutesSelection([]))
                }
                name="mode"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {
        editMode && (
          <>
            <Divider />
            <Grid item>
              <Box padding={1}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <Typography variant="caption" color="textSecondary">
                      Selezione giri
                    </Typography>
                  </Grid>
                  <Grid item>
                    <IconButton
                      onClick={() => setOpenRoutesDialog(true)}
                      title="Seleziona giro"
                    >
                      <ListAltIcon />
                    </IconButton>
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {routes.length <= 0 ? (
                    <Typography variant="body1" color="textPrimary">
                      Nessun giro selezionato
                    </Typography>
                  ) : (
                    <RadioGroup
                      aria-label="giri"
                      name="route"
                      value={selectedRoute ? selectedRoute.id! : null}
                      row
                      onChange={(e, value) =>
                        updateSelectedRoute(
                          parseInt(value),
                          Object.values(routesData)
                        )
                      }
                    >
                      {routes.map((route: any) => {
                        return (<FormControlLabel
                          key={route.id!}
                          value={route.id!}
                          control={<Radio />}
                          label={`${route.id!}/${route["tags_objects"].map((tag: any) => tag.label).join(", ")}`}
                        />
                        )
                      }
                      )}
                    </RadioGroup>
                  )}
                </Grid>
              </Box>
            </Grid>
          </>
        )
      }
      <Divider />

      <Grid item container direction="column">
          <Grid item container>
            <Grid item xs={user?.is_carrier ? 6 : 4}>
              <Box padding={1}>
                <Typography variant="caption" color="textSecondary">
                  Automezzo
                </Typography>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="body1" color="textPrimary">
                    {vehicle ? vehicle.internal_code : "-------"}
                  </Typography>
                  <IconButton
                    onClick={() => setOpenVehicleDialog(true)}
                    title="Seleziona automezzo"
                  >
                    <LocalShippingIcon />
                  </IconButton>
                </Grid>
              </Box>
            </Grid>
            <Divider />

            <Grid item xs={user?.is_carrier ? 6 : 4}>
              <Box padding={1}>
                <Typography variant="caption" color="textSecondary">
                  Autista
                </Typography>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="body1" color="textPrimary">
                    {driver ? `${driver.surname} ${driver.name}` : "-------"}
                  </Typography>
                  <IconButton
                    onClick={() => setOpenDriverDialog(true)}
                    title="Seleziona autista"
                  >
                    <PersonIcon />
                  </IconButton>
                </Grid>
              </Box>
            </Grid>
              {
                  user?.is_carrier ? null : (
                      <Grid item xs={4}>
                          <Box padding={1}>
                              <Typography variant="caption" color="textSecondary">
                                  Vettore
                              </Typography>
                              <Grid
                                  container
                                  justifyContent="space-between"
                                  alignItems="center"
                              >
                                  <Typography variant="body1" color="textPrimary">
                                      {carrier
                                          ? `${carrier.id} ${carrier.business_name}`
                                          : "-------"}
                                  </Typography>
                                  <IconButton
                                      onClick={() => setOpenCarrierDialog(true)}
                                      title="Seleziona vettore"
                                      disabled={user?.is_carrier}
                                  >
                                      <FaPeopleCarryBox />
                                  </IconButton>
                              </Grid>
                          </Box>
                          {
                              false && carrier && !driver && <Box padding={1}>
                              <Typography variant="caption" color="textSecondary">
                                  Nascondi giro 2
                              </Typography>
                              <Grid
                                  container
                                  justifyContent="space-between"
                                  alignItems="center"
                              >
                                  <Switch
                                      disabled={editMode}
                                      checked={createBorderaux}
                                      onChange={() =>
                                          setCreateBorderaux(!createBorderaux)
                                      }
                                      name="mode"
                                  />
                              </Grid>
                          </Box>
                          }
                      </Grid>
                  )
              }


          </Grid>


        <Divider />

        <Grid item>
          <Box padding={1}>
            <Form
              initialValues={{
                finalPoint: finalPointId,
                startPoint: startPointId,
                tags: tags,
                start_date: startDate,
              }}
              onSubmit={() => { }}
              render={() => (
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{ marginBottom: "-20px" }}>
                    <ReferenceArrayInput
                      variant="outlined"
                      onChange={(value: any) => {
                        updateTags(value)
                      }}
                      reference="autocomplete/tag"
                      defaultValue={[]}
                      source="tags"
                      isRequired={true}
                      label="Tag"
                      sort={{ "field": "label", "order": "ASC" }}
                      className="filter-field-small">
                      <AutocompleteArrayInput optionText="label" fullWidth />
                    </ReferenceArrayInput>
                  </Grid>
                  <Grid item xs={6}  style={{ marginBottom: "-20px" }}>
                    <ReferenceInputSubject
                      onChange={(value: any) => updateStartPointId(value)}
                      fullWidth
                      allowEmpty={false}
                      source="startPoint"
                      label="Punto iniziale"
                      required={true}
                      helperText={false}
                      filter={{ type: "planner_receiver" }}
                    />
                  </Grid>
                  <Grid item xs={6}  style={{ marginBottom: "-20px" }}>
                    <ReferenceInputSubject
                      onChange={(value: any) => {
                        updateFinalPointId(value)
                      }}
                      fullWidth
                      allowEmpty={false}
                      source="finalPoint"
                      label="Punto finale"
                      required={true}
                      helperText={false}
                      filter={{ type: "planner_receiver" }}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <DateTimeInput
                      label="Ora inizio"
                      onChange={(date) => updateStartDate(new Date(date.target.value))}
                      isRequired={true}
                      source="start_date"
                      variant="outlined"
                      fullWidth
                      helperText={false}
                    />
                  </Grid>
                  <Grid item xs={4}>
                      <TextField
                          fullWidth
                          disabled
                          label="Ora fine"
                          variant="outlined"
                          margin="dense"
                          value={
                              props.endDateValue
                                  ? props.endDateValue.toLocaleString("it-IT")
                                  : ""
                          }
                      />
                  </Grid>
                  <Grid item xs={2}>
                      <TextField value={props.duration || "0:00"} disabled label="Durata" variant="outlined" margin="dense"/>
                  </Grid>
                  {user?.is_admin === true && (
                    <Grid item xs={1}>
                      <Button onClick={() => setEtaDetailsOpen(true)} title="Dettaglio calcolo ETA">
                        ETA
                      </Button>
                    </Grid>
                  )}
                    {
                        user?.is_admin === true &&
                        <div style={{display: "absolute", top: "0", right: "0"}}>
                            <Button onClick={() => {
                                updateStartDate(new Date());
                                updateStartPointId(710);
                                updateFinalPointId(710);
                            }}><Typography>x</Typography></Button>
                        </div>
                    }
                </Grid>
              )}
            />
          </Box>
        </Grid>
      </Grid>
      <Divider />
      {
        warehouseAlert && (
          <Typography align="center" variant="h3" color="error">
            Merce non in sede!
          </Typography>)
      }
      <Box padding={1} display="flex" justifyContent="space-between">
        <ButtonGroup variant="text" color="primary">
          <Button
            disabled={groupedDeliveries.length <= 0}
            onClick={() => setOpenSplitSegmentsDialog(true)}
          >
            Spezza tratte
          </Button>
          <Button onClick={simulateRouteAssignment} disabled={simulateButtonDisabled || user?.is_carrier}>
            Simula € Vett.
          </Button>
        </ButtonGroup>
        <ButtonGroup variant="text" color="primary">
          <Button
            onClick={ignoreEtaWarning}
            disabled={
              canSaveForEta === ""
            }
            title="Ignora eta"
          >
            {canSaveForEtaTemp > 0 ? `(${canSaveForEtaTemp})` : "Ignora eta"}
          </Button>
          <Button
            onClick={invertRouteOrder}
            disabled={
              groupedDeliveries.length <= 0 ||
              !startPointSubject ||
              !finalPointSubject ||
              warehouseAlert
            }
          >
            Inverti ordine
          </Button>
          <Button
            disabled={
              groupedDeliveries.length <= 0 ||
              !startPointSubject ||
              !finalPointSubject ||
              warehouseAlert
            }
            onClick={autoOrder}
          >
            Ordina auto
          </Button>
          <Button onClick={saveRoute} disabled={saveButtonDisabled}>
            {props.routingReady ? "Salva" : "Ricalcolo percorso..."}
          </Button>
        </ButtonGroup>
      </Box>
      <Box display="flex">
        <TableContainer style={{ flexGrow: 1 }}>
          <TableGroupedDeliveries
            onOrdering={reorderGroupedDeliveries}
            onDeleteItem={deleteDeliveries}
            data={groupedDeliveries}
            endPoint={props.finalPointSubject as Subject}
            pointsDistanceMapping={pointsDurationMapping}
            startDate={startDate}
            endDate={props.endDate}
            setCanSaveForEta={setCanSaveForEta}
            canSaveForEta={canSaveForEta}
          />
        </TableContainer>
      </Box>
      {user?.is_admin === true && (
        <EtaCalculationDialog
          open={etaDetailsOpen}
          onClose={() => setEtaDetailsOpen(false)}
          etaParams={props.etaParams}
          etaParamsLoaded={props.etaParamsLoaded}
          auditEnabled={props.etaAuditEnabled}
          onCapture={props.onCaptureEtaAudit}
          totalDistance={props.totalDistance}
          totalRoutingDuration={props.totalRoutingDuration}
          totalEtaDuration={props.totalEtaDuration}
          finalPointName={props.finalPointSubject?.business_name}
          groupedDeliveries={groupedDeliveries}
          addedSegments={addedSegments}
          pointsDurationMapping={pointsDurationMapping || []}
        />
      )}
    </Drawer >
  );
};
